<template>
  <el-alert
    class="mb-24"
    type="warning"
    :description="$t('profile.contact-list.alert')"
    show-icon
    hide-close
    card
    data-test-id="contact-form.alert"
  />
</template>

<script>
export default {
  name: 'ContactFormAlert'
};
</script>
